module.exports = __webpack_public_path__ + "static/indication-icons-rcc-dd1e1cd7bec40ecdd1d8ecb80f4c4c17.png";